// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8659":"css/admin-app.6919","9542":"css/app.6919"}[chunkId] + ".css";
};